import directives from './module';

class LightLanding implements ng.IComponentController {
    data: anm.YoutubeLightLanding | anm.PlayerLightLanding;
    previewUrl: string;

    $onInit() {
        this.previewUrl = require('../../images/landing/light/' + this.data.preview);
    }
}

directives.component('lightLanding', {
    bindings: {
        data: '<'
    },
    controller: LightLanding,
    templateUrl: require('landing/light/light-landing.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/LightLanding.ts